/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Priority_None_OptionInputs */

const en_explorer_info_priority_none_option = /** @type {(inputs: Explorer_Info_Priority_None_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`None`)
};

const fr_explorer_info_priority_none_option = /** @type {(inputs: Explorer_Info_Priority_None_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`None`)
};

const de_explorer_info_priority_none_option = /** @type {(inputs: Explorer_Info_Priority_None_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`None`)
};

const it_explorer_info_priority_none_option = /** @type {(inputs: Explorer_Info_Priority_None_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`None`)
};

const ru_explorer_info_priority_none_option = /** @type {(inputs: Explorer_Info_Priority_None_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`None`)
};

const es_explorer_info_priority_none_option = /** @type {(inputs: Explorer_Info_Priority_None_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`None`)
};

const zh_cn2_explorer_info_priority_none_option = /** @type {(inputs: Explorer_Info_Priority_None_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`None`)
};

const ja_explorer_info_priority_none_option = /** @type {(inputs: Explorer_Info_Priority_None_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`None`)
};

const hi_explorer_info_priority_none_option = /** @type {(inputs: Explorer_Info_Priority_None_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`None`)
};

const pt_pt2_explorer_info_priority_none_option = /** @type {(inputs: Explorer_Info_Priority_None_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`None`)
};

/**
* | output |
* | --- |
* | "None" |
*
* @param {Explorer_Info_Priority_None_OptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_priority_none_option = /** @type {((inputs?: Explorer_Info_Priority_None_OptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Priority_None_OptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_info_priority_none_option(inputs)
	if (locale === "de") return de_explorer_info_priority_none_option(inputs)
	if (locale === "it") return it_explorer_info_priority_none_option(inputs)
	if (locale === "ru") return ru_explorer_info_priority_none_option(inputs)
	if (locale === "es") return es_explorer_info_priority_none_option(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_info_priority_none_option(inputs)
	if (locale === "ja") return ja_explorer_info_priority_none_option(inputs)
	if (locale === "hi") return hi_explorer_info_priority_none_option(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_info_priority_none_option(inputs)
	return en_explorer_info_priority_none_option(inputs)
});